module.exports = __webpack_public_path__ + "media/images/clipboard-7a5cbb1c4e61247a6fe525a3f2c808d0.svg";